export default __webpack_public_path__ + "static/34-3716c2bbfbead4325a531ef82de2ba34.png";